import React, { useEffect, useState } from "react";
import images from '../../themes/appImage';
import appconstants from "../../themes/appconstant";
import { useLocation } from "react-router-dom";
import { EyeInvisibleOutlined, EyeOutlined } from "@ant-design/icons";
import * as Yup from "yup";
import { Formik, Form, Field, ErrorMessage } from "formik";
import { useDispatch, useSelector } from "react-redux";
import { checkLinkLoad, resetPasswordLoad } from "../../redux/slices/auth.slice";
import ButtonLayout from "../../common/layoutButton";
import Linkfailed from "./link-failed";

const NewPassword = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const query = new URLSearchParams(location.search);
  const token = query.get("token");

  useEffect(() => {
    const data = {
      token: token
    }
    dispatch(checkLinkLoad(data));
  }, [dispatch, token]);

  const initialValues = {
    password: "",
    retypePassword: "",
  };

  const validationSchema = Yup.object().shape({
    password: Yup.string()
      .required("Password is required")
      .min(8, "Password must be at least 8 characters long"),
    retypePassword: Yup.string()
      .required("Retype password is required")
      .oneOf([Yup.ref("password")], "Passwords must match"),
  });

  const [showPassword, setShowPassword] = useState(false);
  const [retypePassword, setRetypePassword] = useState(false);
  
  const retpeTogglePassword = () => {
    setRetypePassword(!retypePassword);
  };
  
  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };
  
  const handleSubmit = (values) => {
    const body = {
      password: values.password,
      token: token
    }
    dispatch(resetPasswordLoad(body));
  };

  const linkValid = useSelector((state) => state.authReducer.linkValid);

  if (linkValid === null) {
    return null;
  }

  return (
    <>
      {!linkValid ? (
        <Linkfailed />
      ) : (
        <div className="w-[100vw] h-[100vh] bg-background flex flex-col items-center justify-between">
          <div className="max-w-[424px] max-h-[455px] flex items-center flex-col mt-5">
            <img className="mb-5" src={images.appLogo} alt="metafit-logo" />
            <div className="w-full bg-white border shadow-metafit-shadow rounded-lg p-5 md:p-2 sm:w-[100vw]">
              <div className="text-2xl font-semibold text-dark text-center my-4">
                {appconstants.createNewPassword}
              </div>
              <div className="text-sm text-center text-gray60 mb-5">
               
              </div>
              <Formik
                initialValues={initialValues}
                validationSchema={validationSchema}
                onSubmit={handleSubmit}
              >
                <Form className="max-w-sm mx-auto">
                  <div className="mb-5 relative">
                    <label
                      htmlFor="password"
                      className="block mb-2 text-sm font-[400] text-dark"
                    >
                      {appconstants.password}
                      <span className="text-[#D33030]">*</span>
                    </label>
                    <Field
                      type={retypePassword ? "text" : "password"}
                      id="password"
                      name="password"
                      className="border border-gray-300 text-dark text-sm rounded-lg block w-full py-[12px] px-[16px] pr-[35px] h-[48px] focus:outline-none focus:border-gray-300"
                      placeholder={appconstants.passwordPlaceHolder}
                    />
                    {retypePassword ? (
                      <EyeOutlined
                        className="absolute right-3 top-[44px] transform -translate-y-50 cursor-pointer"
                        onClick={retpeTogglePassword}
                        style={{ color: "#2F2F2F66" }}
                      />
                    ) : (
                      <EyeInvisibleOutlined
                        className="absolute right-3 top-[44px] transform -translate-y-50 cursor-pointer"
                        onClick={retpeTogglePassword}
                        style={{ color: "#2F2F2F66" }}
                      />
                    )}
                    <ErrorMessage
                      name="password"
                      component="div"
                      className="text-red-500 text-xs font-normal"
                    />
                  </div>
                  <div className="mb-5 relative">
                    <label
                      htmlFor="retypePassword"
                      className="block mb-2 text-sm font-[400] text-dark"
                    >
                      {appconstants.retypePassword}
                      <span className="text-[#D33030]">*</span>
                    </label>
                    <Field
                      type={showPassword ? "text" : "password"}
                      id="retypePassword"
                      name="retypePassword"
                      className="border border-gray-300 text-dark text-sm rounded-lg block w-full py-[12px] px-[16px] pr-[35px] h-[48px] focus:outline-none focus:border-gray-300"
                      placeholder={appconstants.retypePasswordPlaceHolder}
                    />
                    {showPassword ? (
                      <EyeOutlined
                        className="absolute right-3 top-[44px] transform -translate-y-50 cursor-pointer"
                        onClick={togglePasswordVisibility}
                        style={{ color: "#2F2F2F66" }}
                      />
                    ) : (
                      <EyeInvisibleOutlined
                        className="absolute right-3 top-[44px] transform -translate-y-50 cursor-pointer"
                        onClick={togglePasswordVisibility}
                        style={{ color: "#2F2F2F66" }}
                      />
                    )}
                    <ErrorMessage
                      name="retypePassword"
                      component="div"
                      className="text-red-500 text-xs font-normal"
                    />
                  </div>
                  <div className="mb-5">
                    <ButtonLayout
                      text="Submit"
                      className="login-btn"
                      type="submit"
                    />
                  </div>
                </Form>
              </Formik>
            </div>
          </div>
          <div className="text-sm text-light mb-3">
            {appconstants.metafitRights}
          </div>
        </div>
      )}
    </>
  );
};

export default NewPassword;
